"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogListHelper = void 0;
var log_1 = require("./log");
var LogListHelper = (function () {
    function LogListHelper() {
    }
    LogListHelper.level_1 = function (handler, list, prefix, sep) {
        if (prefix === void 0) { prefix = ""; }
        if (sep === void 0) { sep = "\n"; }
        var addSuffix = function (val, index) { return prefix + "[" + index + "]=" + handler(val); };
        return log_1.Log.w(3, log_1.Log.join)(sep)(log_1.Log.map(addSuffix, list));
    };
    LogListHelper.level_2 = function (handlerLevel_1, handlerLevel_2, list, prefix) {
        if (prefix === void 0) { prefix = ""; }
        var addSuffix = function (index_1, val, index_2) { return "[" + index_1 + "][" + index_2 + "]=" + handlerLevel_2(val); };
        var levelOneHandler = function (el, ind) { return "" + prefix + log_1.Log.join(log_1.Log.splitBy, log_1.Log.map(log_1.Log.w(3, addSuffix)(ind), handlerLevel_1(el))); };
        return log_1.Log.w(3, log_1.Log.join)("\n")(log_1.Log.map(levelOneHandler, list));
    };
    return LogListHelper;
}());
exports.LogListHelper = LogListHelper;
